import axios from 'axios';
import { getAccessToken } from '@/services/tokenStorage';

function resolveApiBaseUrl() {
  const raw = process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_DEV_URL
    : 'https://api.bernoullirisk.com/api';
  return String(raw || 'https://api.bernoullirisk.com/api').replace(/\/?$/, '');
}

function resolveAxiosUrl(baseURL, apiUrl) {
  if (/^https?:\/\//i.test(apiUrl)) {
    return { baseURL: undefined, url: apiUrl };
  }
  const base = `${String(baseURL).replace(/\/?$/, '/')}`;
  const path = String(apiUrl || '').replace(/^\//, '');
  return { baseURL: base, url: path };
}

const CallAPI = async (apiUrl, method, headers, data = null, params = null) => {
  try {
    const accessToken = getAccessToken();
    const resolved = resolveAxiosUrl(resolveApiBaseUrl(), apiUrl);

    const response = await axios({
      method,
      url: resolved.url,
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        ...headers,
      },
      data,
      params,
      withCredentials: true,
      baseURL: resolved.baseURL,
    });
    return response.data;
  } catch (error) {
    if (error && error.response && error.response.data) return error.response.data;
    throw error;
  }
};

module.exports = {
  CallAPI,
};
